import React from "react";
import SparkLine from "../sparkline/SparkLine";
import { SparkLineProps } from "../sparkline/SparkLineTypes";

const SparkLineAdvanced: React.FC<SparkLineProps> = (props) => {
  return <SparkLine {...props} advanced />;
}

export default SparkLineAdvanced;